import React from "react";
import { Helmet } from "react-helmet-async";

export default function MetaTags({ blogId, title, pageImage }) {
  const pageTitle = "SOS PAPA MORIS";
  const pageUrl = `https://sospapa-moris.com/blogs/${blogId}`;

  return (
    <Helmet>
      <meta name="title" content={pageTitle} />
      <meta name="description" content={title} />

      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={title} />
      <meta property="og:image" content={pageImage} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:type" content="website" />
    </Helmet>
  );
}
